var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "carousel slide",
      attrs: { id: "carousel-display", "data-ride": "carousel" },
    },
    [
      _c(
        "ol",
        { staticClass: "carousel-indicators" },
        _vm._l(_vm.slides, function (_, index) {
          return _c("li", {
            key: index,
            class: { active: !index },
            attrs: {
              "data-target": "#carousel-display",
              "data-slide-to": index,
            },
          })
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "carousel-inner text-center py-5 py-md-0" },
        _vm._l(_vm.slides, function (slide, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "carousel-item",
              class: { active: !index },
            },
            [
              _c("omegaup-homepage-slide", {
                attrs: {
                  title: slide.title[_vm.T.locale] || slide.title["es"],
                  description:
                    slide.description[_vm.T.locale] || slide.description["es"],
                  "image-src": slide.image,
                  button: slide.button,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "a",
        {
          staticClass: "carousel-control-prev",
          attrs: {
            href: "#carousel-display",
            role: "button",
            "data-slide": "prev",
          },
        },
        [
          _c("span", {
            staticClass: "carousel-control-prev-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.T.wordsPrevious)),
          ]),
        ]
      ),
      _c(
        "a",
        {
          staticClass: "carousel-control-next",
          attrs: {
            href: "#carousel-display",
            role: "button",
            "data-slide": "next",
          },
        },
        [
          _c("span", {
            staticClass: "carousel-control-next-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.T.wordsNext)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }